module.exports = __webpack_public_path__ + "media/images/flags/mw-33e950c65f58447f1b81e38f741517d0.svg";